import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { LoadingPage, NotFound } from "../components";
import { ErrorPage } from "../shared";
import {
  HomePage,
  ServicePage,
  TransactionPage,
  VerifyDocumentPage,
} from "../pages";
import { AuthProvider, JourneyScope, PortalProvider } from "../provider";

const Nav = () => (
  <Suspense fallback={<LoadingPage />}>
    <AuthProvider>
      {/* Strictly INSIDE AuthProvider, which holds its children back until a
          token exists. PortalProvider reads that token during render, so above
          this line it read an empty value on every first visit and its query
          stayed disabled forever -- a child's write cannot re-render a parent.
          Ten other render-time token reads already sit below this gate. */}
      <PortalProvider>
        <Routes>
          {/* Static first segment: /:corporateName is greedy and would
              otherwise swallow every verify link as a company name. A bare
              root has no corporate context, so it uses the generic error page
              rather than attempting to resolve a tenant. */}
          <Route path="/verify/:reference" element={<VerifyDocumentPage />} />
          <Route path="/" element={<ErrorPage />} />
          {/* A payment link under its own first segment. The same three
              pages as a page name gets: which entry this is, and so which
              lookup is made, is decided from the address by PortalProvider.
              A link id with no prefix needs no route of its own -- it is
              shaped like a page name and matches the routes below. */}
          <Route path="/paylink/:uuid" element={<HomePage />} />
          {/* The service and its outcome share one parent, which holds the
              journey state, so Try again returns with every entry kept. */}
          <Route path="/paylink/:uuid/:id" element={<JourneyScope />}>
            <Route index element={<ServicePage />} />
            <Route
              path="transaction/:transactionId"
              element={<TransactionPage />}
            />
          </Route>
          <Route path="/:corporateName" element={<HomePage />} />
          <Route path="/:corporateName/:id" element={<JourneyScope />}>
            <Route index element={<ServicePage />} />
            <Route
              path="transaction/:transactionId"
              element={<TransactionPage />}
            />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PortalProvider>
    </AuthProvider>
  </Suspense>
);

export default Nav;
